module.exports = __webpack_public_path__ + "static/media/blogs.e59f6c4c.jpg";